import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AuthenticationChangePasswordUseCaseInterface } from 'domain/usecases';

export class RemoteAuthenticationChangePassword
  implements AuthenticationChangePasswordUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AuthenticationChangePasswordUseCaseInterface.Params,
  ): Promise<AuthenticationChangePasswordUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.cpf}`,
      body: { ...params, cpf: undefined },
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
